import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    domain = 'autoiXpert.de';
    currentYear = new Date().getFullYear();
}
